import Styles from './useTrialEndedBanner.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { useRootStore } from 'stores/RootStore'
import { Lightning } from 'blaze-ui/icons'
import { useVirtualMarketerPlan } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/hooks/useVirtualMarketerPlan'
import { useModals } from 'almanac-ui/Modal'
import { VirtualMarketerPlansModal } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/VirtualMarketerPlansModal/VirtualMarketerPlansModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { AutopilotPlansModal } from 'components/Settings/Workspace/AutopilotPlans/AutopilotPlansModal'
import { useCampaignsFeatureFlag } from 'hooks/useCampaignsFeatureFlag'
import { useIsActiveOrCanceledPioneerPlan } from 'hooks/useIsActiveOrCanceledPioneerPlan'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'

export const useTrialEndedBanner = () => {
  const isCampaignsEnabled = useCampaignsFeatureFlag()
  const isActiveOrCanceledPioneerPlan = useIsActiveOrCanceledPioneerPlan()
  const { openModal, closeAllModals } = useModals()
  const { isMobile, isIOSNative } = useResponsiveDesign()
  const isAPMobileWeb = useAPMobileWeb()
  const workspace = useCurrentWorkspace()
  const { tierUsageStore } = useRootStore()
  const currentSubscription = tierUsageStore.currentSubscription
  const { data: virtualMarketerPlan } = useVirtualMarketerPlan()
  const hideBanner =
    !workspace ||
    !workspace.is_virtual_marketer ||
    !currentSubscription ||
    !currentSubscription.trial_ended ||
    (workspace.is_ap_freemium && !isAPMobileWeb) ||
    isIOSNative

  // BLZ-14761: aligned with `useOpenAutopilotUpgrade` — Pioneer-era workspaces
  // that trialed (regardless of whether they converted) route to the new
  // Starter/Growth modal.
  const openVirtualMarketerPlansModal = () => {
    if (isCampaignsEnabled || isActiveOrCanceledPioneerPlan) {
      openModal(AutopilotPlansModal)
      return
    }

    if (!virtualMarketerPlan) return

    openModal(VirtualMarketerPlansModal, {
      plan: virtualMarketerPlan,
      onSuccess: () => {
        if (workspace) tierUsageStore.fetch(workspace.id)

        closeAllModals()
      },
    })
  }

  const trialEndedBanner = (
    <div className={Styles.container}>
      <Lightning color="var(--light-100)" />
      <div className={Styles.message}>
        <Text variant="secondary" color="var(--light-100)">
          Your trial has ended. Upgrade now to keep creating.
        </Text>
      </div>
      <div className={Styles.buttonContainer}>
        <Button size={isMobile ? 'sm' : 'xs'} onPress={() => openVirtualMarketerPlansModal()} variant="secondary">
          Upgrade Now
        </Button>
      </div>
    </div>
  )

  return {
    showBanner: !hideBanner,
    trialEndedBanner,
  }
}
